"use client";

import React, { useRef, useState, useEffect } from "react";

interface LazySectionProps {
  children: React.ReactNode;
  placeholderHeight?: string;
  className?: string;
}

export default function LazySection({
  children,
  placeholderHeight = "400px",
  className = "",
}: LazySectionProps) {
  const [isInView, setIsInView] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      setIsInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: "350px 0px", // Trigger mount 350px before the element enters the viewport
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        minHeight: isInView ? "auto" : placeholderHeight,
        display: "block",
        width: "100%",
      }}
    >
      {isInView ? children : null}
    </div>
  );
}
